<template>
  <div class="total-amount">
    <selfcheck-calling-modal :visible="isCalling" @cancel="handleCallStaffCancel" />
    <selfcheck-unhandled-error-modal :visible="hasUnhandledError" @backtotop="handleBackToTop" />
    <selfcheck-browser-back-modal
      :visible="isShowingBrowserBackModal"
      @confirm="handleBrowserBackConfirm"
      @cancel="handleBrowserBackCancel"
    />

    <div class="content">
      <div class="image"><img src="@/assets/images/people.svg" alt="" /></div>
      <div class="heading">{{ $t('selfcheck.singleSeatCheckOut') }}</div>
      <div class="text">{{ $t('selfcheck.multiSeatsCheckOut') }}<br /></div>
    </div>
    <selfcheck-button-footer>
      <li>
        <so-button @click="handleNo">
          {{ $t('common.no') }}
        </so-button>
      </li>
      <li>
        <so-button @click="handleYes">{{ $t('common.yes') }}</so-button>
      </li>
    </selfcheck-button-footer>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import SoButton from '@/components/common/SoButton'
import SelfcheckButtonFooter from '@/components/selfcheck/SelfcheckButtonFooter'
import SelfcheckCallingModal from '@/components/modal/SelfcheckCallingModal'
import SelfcheckUnhandledErrorModal from '@/components/modal/SelfcheckUnhandledErrorModal'
import SelfcheckBrowserBackModal from '@/components/modal/SelfcheckBrowserBackModal'

export default {
  name: 'TotalAmount',
  components: {
    SoButton,
    SelfcheckButtonFooter,
    SelfcheckCallingModal,
    SelfcheckUnhandledErrorModal,
    SelfcheckBrowserBackModal,
  },
  data() {
    return {
      isCalling: false,
      isCanceled: false,
      isShowingBrowserBackModal: false,
      hasUnhandledError: false,
    }
  },
  computed: {
    ...mapGetters({
      seatStatus: 'seat/getSeatStatus',
      isFetching: 'selfcheck/getIsFetching',
      error: 'selfcheck/getError',
    }),
    isApp() {
      return process.env.VUE_APP_TYPE === 'app'
    },
  },
  watch: {
    seatStatus() {
      if (this.seatStatus === 4) {
        this.isCalling = true
      }
      if (this.seatStatus === 0) {
        this.isCanceled = true
        this.$router.replace({ name: 'shopMenu' })
      }
    },
  },
  mounted() {
    // mountedの時点で呼出中の場合 = セルフチェック中ユーザーの呼出中のリロード
    if (this.seatStatus === 4) {
      this.isCalling = true
    }
  },
  beforeRouteLeave(to, _from_, next) {
    // 遷移先が次のページなら常に成功
    if (to.name === 'dishesConfirm') {
      next()
      return
    }
    // キャンセルされていたら離脱
    if (this.isCanceled) {
      next()
      return
    }
    // それ以外（ブラウザバック）の際はモーダルを表示
    this.showBrowserBackModal()
    next(false)
  },
  methods: {
    ...mapActions({
      updateSelfcheckCount: 'selfcheck/updateSelfcheckCount',
      cancelSelfcheck: 'selfcheck/cancelSelfcheck',
      callStaffSelfcheck: 'selfcheck/callStaffSelfcheck',
      setShowingSimpleErrorModal: 'modal/setShowingSimpleErrorModal',
      setShowingSelfcheckErrorModal: 'modal/setShowingSelfcheckErrorModal',
    }),
    async handleYes() {
      await this.updateSelfcheckCount()

      if (!this.error) {
        this.$router.replace({ name: 'dishesConfirm' })
      } else {
        if (this.error.response) {
          if (this.error.response.status === 503) {
            this.isCalling = true
          } else {
            this.hasUnhandledError = true
          }
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
    async handleNo() {
      await this.callStaffSelfcheck()

      if (!this.error) {
        this.isCalling = true
      } else {
        this.isCalling = false
        if (this.error.response) {
          this.hasUnhandledError = true
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
    async cancel(callStaff) {
      await this.cancelSelfcheck({ callStaff })
      if (!this.error) {
        this.isCanceled = true
        this.$router.replace({ name: 'shopMenu' })
      } else {
        if (this.error.response) {
          this.setShowingSelfcheckErrorModal(true)
        } else {
          this.setShowingSimpleErrorModal(true)
        }
      }
    },
    handleCallStaffCancel() {
      this.cancel(false)
    },
    handleBackToTop() {
      this.cancel(true)
    },
    async handleBrowserBackConfirm() {
      await this.cancel(true)
      this.hideBrowserBackModal()
    },
    handleBrowserBackCancel() {
      this.hideBrowserBackModal()
    },
    showBrowserBackModal() {
      this.isShowingBrowserBackModal = true
    },
    hideBrowserBackModal() {
      this.isShowingBrowserBackModal = false
    },
  },
  head: {
    title() {
      return {
        inner: this.$t('selfcheck.comfirmNumbers'),
        complement: this.$t('siteId'),
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.total-amount {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 30px 15px 0;
}
.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
}
.image {
  margin: 0 auto 20px;
  width: 120px;
}
.heading {
  font-size: 20px;
  margin-bottom: 20px;
  white-space: pre-wrap;
}
.text {
  font-size: 14px;
  white-space: pre-wrap;
}
</style>
